module.exports = __webpack_public_path__ + "static/img/goBtn.f83c23e0.png";